<mat-icon [class.disabled]="disabled || first" (click)="disabled || first ? null : shift(index - 1)">arrow_upward</mat-icon>
<mat-icon [class.disabled]="disabled || last" (click)="disabled || last ? null : shift(index + 1)">arrow_downward</mat-icon>
